<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a href="#" rel="noopener">Privacy Policy</a>
            </li>
            <li>
              <a href="#" rel="noopener">Terms</a>
            </li>
            <li>
              <a href="#" rel="noopener">Contact Us</a>
            </li>
          </ul>
        </nav>
        <div class="credits ml-auto">
          <div class="copyright">
            &copy; Coded with
            <i class="fa fa-heart heart"></i> by <a href="https://www.techlegends.com" target="_blank" rel="noopener">Tech Legends</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer'
  }
</script>
<style>
</style>
